export default function ($scope, baseurl, type, pretty_type, municipios, map, google, access_scope) {
    var _ = require('lodash');
    var layer_name = 'Área ' + pretty_type;
    $scope.layers.push({name: layer_name, visible: false});
    var has_access = function() {return _.indexOf($scope.access, access_scope) !== -1;};
    var _r = require('diacritics').remove;
    var _c = new Date().toISOString().slice(0, 15).replace(/\D/g, ""); //will produce yyyymmddhhm

    var areas = _.map(_.map(municipios,'name'), function(m){
        var _url = [baseurl, 'Areas_', _r(type) , '_', _r(m), '.kmz'].join('');
        return {
            url: _url,
            layer: new google.maps.KmlLayer({
                url: _url + '?t=' + _c,
                map:  has_access() ? map : null,
                preserveViewport: true
            }),
            visible: true,
            municipio: m,
            layer_name: layer_name,
            type: _r(type)
    };});

    //refresh fcn
    return function() {
        var _mun_activos = _.map(_.filter($scope.municipios, 'visible'),'name');
        var _layers_activas = _.map(_.filter($scope.layers, 'visible'),'name');
        
        _.each(areas,function(area){
            area.visible = has_access() 
                    && _.indexOf(_mun_activos, area.municipio) !== -1 
                    && _.indexOf(_layers_activas, area.layer_name) !== -1;
        });
        
        _.each(areas, function(a){
            if (a.layer.getMap() !== (a.visible ? map : null)) 
                a.layer.setMap(a.visible ? map : null);
        });
    };
}




// WEBPACK FOOTER //
// ./src/layers/setup.js